module.exports = __webpack_public_path__ + "img/exhibits7.6b698b65.png";